<template>
	<div class="m-l-50 m-t-30 w-1000" style="color:#111">
		<el-form ref="form" :model="form" :rules="rules" label-width="120px">
      <div class="w-500 fl m-r-30">
        <el-form-item label="">
  				<span>企业基本信息</span>
        </el-form-item>
  			<el-form-item label="企业简称" prop="company_name">
  				<el-input v-model.trim="form.company_name" class="h-40 w-300" clearable placeholder="请输入企业名称"></el-input>
        </el-form-item>
        <el-form-item label="企业联系人" prop="company_user">
  				<el-input v-model.trim="form.company_user" class="h-40 w-300" clearable placeholder="请输入企业联系人"></el-input>
        </el-form-item>
        <el-form-item label="联系人职位" prop="company_position">
          <el-input v-model.trim="form.company_position" class="h-40 w-300" clearable placeholder="请输入联系人职位"></el-input>
        </el-form-item>
        <el-form-item label="企业电话" prop="company_phone">
          <el-input v-model.trim="form.company_phone" class="h-40 w-300" clearable placeholder="请输入企业电话"></el-input>
        </el-form-item>
        <el-form-item label="企业邮箱" prop="company_email">
          <el-input v-model.trim="form.company_email" class="h-40 w-300" clearable placeholder="请输入企业邮箱"></el-input>
        </el-form-item>
        <el-form-item label="纳税人性质" prop="vat_type" class="w-500">
          <el-radio-group v-model="form.vat_type">
            <el-radio :label="1">小规模纳税人</el-radio>
            <el-radio :label="2">一般纳税人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="单据二审"  prop="company_2ex">
          <el-radio class="radio" v-model="form.company_2ex" :label="1">开启</el-radio>
          <el-radio class="radio" v-model="form.company_2ex" :label="0">关闭</el-radio>
        </el-form-item>
        <el-form-item label="出纳角色"  prop="company_cashier">
          <el-radio class="radio" v-model="form.company_cashier" :label="1">开启</el-radio>
          <el-radio class="radio" v-model="form.company_cashier" :label="0">关闭</el-radio>
        </el-form-item>
      </div>
      <div class="w-400 fl">
        <el-form-item label="">
  				<span>企业注册信息</span>
        </el-form-item>
        <el-form-item label="企业全称" prop="rise_company_name">
          <el-input v-model.trim="form.rise_company_name" placeholder="请输入企业全称" clearable class="h-40 w-300"></el-input>
        </el-form-item>
        <el-form-item label="纳税人识别号" prop="rise_discern_code">
          <el-input v-model.trim="form.rise_discern_code" placeholder="请输入纳税人识别号" clearable class="h-40 w-300"></el-input>
        </el-form-item>
        <el-form-item label="企业注册地址" prop="rise_company_addr">
          <el-input v-model.trim="form.rise_company_addr" placeholder="请输入企业注册地址" clearable class="h-40 w-300"></el-input>
        </el-form-item>
        <el-form-item label="企业联系电话" prop="rise_company_phone">
          <el-input v-model.trim="form.rise_company_phone" placeholder="请输入企业联系电话" v-on:change="set_phone()" clearable class="h-40 w-300"></el-input>
        </el-form-item>
        <el-form-item label="开户行名称" prop="rise_bank_name">
          <el-input v-model.trim="form.rise_bank_name" placeholder="请输入开户行名称" clearable class="h-40 w-300"></el-input>
        </el-form-item>
        <el-form-item label="开户银行账号" prop="rise_bank_code">
          <el-input v-model.trim="form.rise_bank_code" placeholder="请输入开户银行账号" clearable class="h-40 w-300"></el-input>
        </el-form-item>
      </div>
      <div class="w-900" style="overflow:hidden">
        <el-form-item label="允许使用模块">
        <el-checkbox-group v-model="form.mokuai">
          <el-checkbox v-for="item in mokuai" :label="item.id">{{item.menu_name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="add()" size="small" :loading="isLoading">保 存</el-button>
          <el-button @click="goback()" size="small">返 回</el-button>
        </el-form-item>
      </div>
        <!-- <el-form-item label="发票使用"  prop="company_employ">
          <el-radio class="radio" v-model="form.company_employ" :label="1">开启</el-radio>
          <el-radio class="radio" v-model="form.company_employ" :label="0">关闭</el-radio>
        </el-form-item> -->
        
		</el-form>
	</div>
</template>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  export default {
    data() {
      return {
        keyword: '',
        isLoading: false,
        id: null,
        mokuai: [],
        form: {
          company_name: '',
          company_user: '',
          company_position: '',
          company_phone: '',
          company_email: '',
          vat_type: '',
          company_2ex: '',
          company_cashier: '',
          company_employ: '',
          rise_company_name: '',
          rise_discern_code: '',
          rise_company_addr: '',
          rise_company_phone: '',
          rise_bank_name: '',
          rise_bank_code: '',
          mokuai: []
        },
        rules: {
          company_name: [
            { required: true, message: '请填写企业名称' }
          ],
          rise_company_name: [
            { required: true, message: '请填写企业全称' }
          ],
          rise_discern_code: [
            { required: true, message: '请填写纳税人识别号' }
          ],
          rise_company_addr: [
            { required: true, message: '请填写企业注册地址' }
          ],
          rise_company_phone: [
            { required: true, message: '请填写企业联系电话' }
          ],
          rise_bank_name: [
            { required: true, message: '请填写开户行名称' }
          ],
          rise_bank_code: [
            { required: true, message: '请填写开户银行账号' }
          ],
          vat_type: [
            { required: true, message: '请选择纳税人性质' }
          ],
        }
      }
    },
    methods: {
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPut('admin/company/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      async getCompleteData() {
        this.apiGet('admin/company/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.company_name = data.company_name
            this.form.company_user = data.company_user
            this.form.company_position = data.company_position
            this.form.company_phone = data.company_phone
            this.form.company_email = data.company_email
            this.form.vat_type = data.vat_type
            this.form.company_2ex = data.company_2ex
            this.form.company_cashier = data.company_cashier
            this.form.company_employ = data.company_employ
            this.form.rise_company_name = data.rise_company_name
            this.form.rise_discern_code = data.rise_discern_code
            this.form.rise_company_addr = data.rise_company_addr
            this.form.rise_company_phone = data.rise_company_phone
            this.form.rise_bank_name = data.rise_bank_name
            this.form.rise_bank_code = data.rise_bank_code
            this.form.mokuai = data.mokuai
          })
        })
      },
      get_mokuai() {
        this.apiGet('admin/base/mokuai_list').then((res) => {
          this.handelResponse(res, (data) => {
            this.mokuai = data.list
          })
        })
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getCompleteData()
      this.get_mokuai()
    },
    components: {
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?d152db24